export const goodpageText={
    same:'کالا‌های مشابه',
    empty:'ناموجود',
    selectshop:'انتخاب فروشگاه',
    add:'افزودن به سبد خرید',
    rate:'امتیاز دهید',
    rateText:'امتیاز شما به این محصول',
    rateText2:'از 1 تا 5 امتیاز دهید',
    refrence:'معرفی محصول',
    specific:'مشخصات فنی',
    allshops:'همه فروشگاه‌ها',
    comments:'نظرات و امتیازات',
    ques:'پرسش و پاسخ',
    deliver:'تامین کالا',
    garanty:'گارانتی کالا',
    toman:'تومان',
    unknown:'نام کاربری نمایش داده شود',
    suggest:'خرید این محصول را به شما ',
    cancel:'انصراف',
    done:'ثبت نظر',
    qdone:'ثبت پرسش',
    adone:'ثبت پاسخ',
    Commenttext:'متن نظر ',
    questext:'متن پرسش ',
    anstext:'متن پاسخ ',
    notfind:'موردی ثبت نشده است',
    razi:'خرید این محصول را پیشنهاد می کنم',
    narazi:'خرید این محصول را پیشنهاد نمی کنم',
    binazar:'برای خرید این محصول نظری ندارم',
    commentText:'شماهم درباره این کالا دیدگاه ثبت کنید',
    questionText:'پرسش و پاسخ خود را درباره این کالا ثبت کنید.',
    replyText:'پاسخ شما به این سوال:',
    loginCommnet:'اگر این محصول را از لوکسین لوکس خریداری کرده اید ، می توانید با ورود به حساب کاربری ، نظر خود را ثبت کنید.',
    login:'برای افزودن نظر وارد حساب کاربری شوید ',
    howcomment:'چطور می توانم در مورد این کالا نظر بدهم؟',
    customer:'کاربر لوکسین لوکس',
    userUnkownq :'پرسش شما بدون نام و ناشناس ثبت گردد ',
    userUnkowna :'پاسخ شما بدون نام و ناشناس ثبت گردد ',
    more :'مشاهده بیشتر'
}